// src/modules/Literature/AdvancedSearchForm.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Button, Grid } from "semantic-ui-react";
import Overridable from "react-overridable";
import { withState } from "react-searchkit";

const AdvancedSearchForm = ({ updateQueryState, currentQueryState }) => {
  const [author, setAuthor] = useState("");
  const [volume, setVolume] = useState("");
  const [subject, setSubject] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  const handleSubmit = () => {
    const filters = [];
    let queryParts = [];

    if (author) {
      queryParts.push(`authors.full_name:(${author})`);
      filters.push(["authors.full_name", author]);
    }
    if (volume) {
      // 👇 Use edition instead of journal_volume
      queryParts.push(`edition:"${volume}"`);
      filters.push(["edition", volume]);
    }
    if (subject) {
      queryParts.push(`subjects.value:${subject}`);
      filters.push(["subjects.value", subject]);
    }
    if (dateFrom || dateTo) {
      queryParts.push(
        `publication_year:[${dateFrom || "*"} TO ${dateTo || "*"}]`
      );
      filters.push([
        "publication_year",
        `${dateFrom || "*"}->${dateTo || "*"}`,
      ]);
    }

    const queryString = queryParts.join(" AND ");

    updateQueryState({
      ...currentQueryState,
      queryString,
      sortBy: "bestmatch",
      filters,
    });
  };

  const handleClear = () => {
    setAuthor("");
    setVolume("");
    setSubject("");
    setDateFrom("");
    setDateTo("");

    updateQueryState({
      ...currentQueryState,
      queryString: "",
      filters: [],
      sortBy: "",
    });
  };

  return (
    <Overridable id="LiteratureSearch.AdvancedSearchForm.layout">
      <Form onSubmit={handleSubmit} className="advanced-search-form">
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column>
              <Form.Input
                label="Author"
                placeholder="Enter author name"
                value={author}
                onChange={(e, { value }) => setAuthor(value)}
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Input
                label="Edition (Volume)"
                placeholder="Enter edition (e.g., 4x)"
                value={volume}
                onChange={(e, { value }) => setVolume(value)}
              />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Form.Input
                label="Subject"
                placeholder="Enter subject"
                value={subject}
                onChange={(e, { value }) => setSubject(value)}
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Group widths="equal">
                <Form.Input
                  type="number"
                  min="0"
                  max={new Date().getFullYear()}
                  step="1"
                  label="Year From"
                  value={dateFrom}
                  onChange={(e, { value }) => setDateFrom(value)}
                />
                <Form.Input
                  type="number"
                  min="0"
                  max={new Date().getFullYear()}
                  step="1"
                  label="Year To"
                  value={dateTo}
                  onChange={(e, { value }) => setDateTo(value)}
                />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16} textAlign="right">
              <Button primary type="submit">
                Apply Filters
              </Button>
              <Button type="button" onClick={handleClear}>
                Clear
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </Overridable>
  );
};

AdvancedSearchForm.propTypes = {
  updateQueryState: PropTypes.func.isRequired,
  currentQueryState: PropTypes.object,
};

AdvancedSearchForm.defaultProps = {
  currentQueryState: {},
};

export default Overridable.component(
  "LiteratureSearch.AdvancedSearchForm",
  withState(AdvancedSearchForm) // <-- wrap withState
);
